import { readableMsgTypes } from 'hooks/useWebsocketTypes';
import { ChatMessage, messageStatusEnum } from 'types/chatsType';

type FilterUnreadMessagesParams = {
  messages: ChatMessage[];
  myId: string;
};

const isReadable = (message: ChatMessage): boolean => readableMsgTypes.includes(message.type);

const isMyMessage = ({ messageOwnerId, myId }: { messageOwnerId: string | null; myId: string }): boolean =>
  messageOwnerId === myId;

const isIncomingUnread = (message: ChatMessage): boolean => message.read !== messageStatusEnum.read;

export const filterUnreadMessages = ({ messages, myId }: FilterUnreadMessagesParams): number[] =>
  messages
    .filter(
      (message) =>
        isReadable(message) && !isMyMessage({ messageOwnerId: message.ownerId, myId }) && isIncomingUnread(message)
    )
    .map((message) => message.id);
